
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 28","data-token-name":"comment-history"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 4.857V7l2.678 2.679M1 7a6 6 0 1012 0A6 6 0 001 7z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7 13v8.667C7 22.377 7.622 23 8.333 23H11v4l5.333-4h9.334c.71 0 1.333-.622 1.333-1.333V7H13m-2.977 10.227h6.666m2.489 0h4.71M10.023 19.98h4.71m6.845 0h2.31m-6.844 0h2.4","stroke":"currentColor","stroke-width":"1.25","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    